import { gql, useQuery } from "@apollo/client";
import {
  mapPropertySearchByIdQuery,
  MapPropertySearchById,
  PropertyDateRangeInput,
  ContextInput,
} from "__generated__/api";
import PropertySearch = MapPropertySearchById.PropertySearch;

const mapPropertySearchById = gql`
  ${mapPropertySearchByIdQuery}
`;

export type MapPropertySearchByIdResponse = { propertySearch: PropertySearch };

export function useMapPropertySearchByIdQuery(
  propertyIds: string[],
  dateRange: PropertyDateRangeInput,
  bexApiContext: ContextInput,
  shouldSkip?: boolean
) {
  const variables = {
    context: bexApiContext,
    propertyIds,
    dateRange,
  };

  return useQuery<MapPropertySearchByIdResponse>(mapPropertySearchById, {
    variables,
    skip: shouldSkip,
  });
}

export default useMapPropertySearchByIdQuery;
